import React from "react";
import CustomTable from "../../components/CustomTable";
import { getCategories, getCities } from "../../../services/CommonServices";
import AddUpdateCategory from "./AddUpdate";
import { categoryValidationSchema } from "../../../utils/validationSchemas/MasterDataSchema";

const Category = () => {
  const columns = [
    {
      label: "#",
      render: (row, index, currentPage, pageSize) => (
        <span>{(currentPage - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      label: "Name",
      key: "name",
    },
  ];
  const modalConfig = {
    initialValues: {
      name: "",
      icon: "",
      base_color: "",
      border_color: "",
      gradient_color_1: "",
      gradient_color_2: "",
      format_duration: []
    },
    validationSchema: categoryValidationSchema,
    apiUrl: "master/categories",
    FormComponent: AddUpdateCategory,
    addTitle: "Add Art Form",
    updateTitle: "Update Art Form",
    extraProps: {},
  };
  return (
    <CustomTable
      title="Art Forms"
      addBtnTitle="Add New Art Form"
      columns={columns}
      getHook={getCategories}
      store={"category"}
      deleteHook={"master/categories"}
      formModal={true}
      modalConfig={modalConfig}
    />
  );
};

export default Category;
